import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import General from './General.js';
import Introduction from './Introduction/Introduction.js';
import { getEventMasterlistBasicData } from '../../services/EventMasterlist.js';
import MyTabsNested from '../../components/MyTabsNested.js';
import Basic from './Basic.js';
import FirstFeaturesCompetitionJury from './Introduction/FirstFeaturesCompetitionJury.js';
import AsianArabCompetitionJury from './Introduction/AsianArabCompetitionJury.js';
import IndianCompetitionJury from './Introduction/IndianCompetitionJury.js';
import AboutUs from './Introduction/AboutUs.js';
import Preface from './Introduction/Preface.js';
import Highlights from './Introduction/Highlights.js';
import Venue from './Introduction/Venue.js';
import Team from './Introduction/Team.js';
import NetworkForPromotionOfAsianCinema from './Introduction/NetworkForPromotionOfAsianCinema.js';
import Fipresci from './Introduction/Fipresci.js';
import { useSelector } from 'react-redux';
import Sections from '../../CommonComponents/Sections.js';
import MyAccordionNested from '../../components/MyAccordionNested.js';
import ResearchCentre from '../../FunctionalComponents/ResearchCentre/ResearchCentre.js';
import Library from '../../FunctionalComponents/ResearchCentre/Library.js';
import Archive from '../../FunctionalComponents/ResearchCentre/Archive.js';
import BodyOfWork from '../EventList/BodyOfWork/BodyOfWork.js';
import Screenings from '../EventList/BodyOfWork/Screenings.js';
import SeminarsConferences from '../EventList/BodyOfWork/SeminarsConferences.js';

const EditEventMasterlistRecord = () => {

  const { alias } = useParams();
  const [eventMasterlistTitle, setEventMasterlistTitle] = useState();
  const [isEventExhibition, setIsEventExhibition] = useState(false);
  const previewEnabled = useSelector(state => state.preview.isEnabled);

  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const eventType = pathParts?.[1];
  const navigate = useNavigate();
  const IntroductionWithProps = useCallback(() => <Introduction isEventExhibition={isEventExhibition} />, [isEventExhibition]);

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: General, subTabs: [
        { id: "primary", title: "Primary", Component: Basic },
        { id: "sections", title: "Sections", Component: Sections },
      ]
    },
    {
      id: "introduction", title: "Introduction", Component: IntroductionWithProps, subTabs: isEventExhibition ? [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "team", title: "Team", Component: Team },
        { id: "venue", title: "Venue", Component: Venue },
        { id: "highlights", title: "Highlights", Component: Highlights },
      ] : [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "about-us", title: "About Us", Component: AboutUs },
        { id: "indian-competition-jury", title: "Indian Competition Jury", Component: IndianCompetitionJury },
        { id: "asian-arab-competition-jury", title: "Asian Arab Competition Jury", Component: AsianArabCompetitionJury },
        { id: "first-features-competition-jury", title: "First Features Competition Jury", Component: FirstFeaturesCompetitionJury },
        { id: "network-for-promotion-of-asian-cinema", title: "Network For Promotion Of Asian Cinema", Component: NetworkForPromotionOfAsianCinema },
        { id: "fipresci", title: "FIPRESCI", Component: Fipresci },
      ]
    },
    {
      id: "research-centre", title: "Research Centre", Component: ResearchCentre, subTabs: [
        { id: "library", title: "Library", Component: Library },
        { id: "archive", title: "Archive", Component: Archive }
      ]
    },
    {
      id: "body-of-work", title: "Body Of Work", Component: BodyOfWork, subTabs: [
        { id: "screenings", title: "Screenings", Component: Screenings },
        { id: "seminars-conferences", title: "Seminars and Conferences", Component: SeminarsConferences }
      ]
    },
  ], [IntroductionWithProps, isEventExhibition]);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getEventMasterlistBasicData(alias);
          if (result) {
            setEventMasterlistTitle(result?.data[0]?.title || result?.data[0]?.full_name);
            if (result && result.data[0] && result.data[0].masterlist_type && result.data[0].masterlist_type === 'Group Exhibition') {
              setIsEventExhibition(true)
            }
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/${eventType}/${alias}/agraphy/${tabs[0].id}/${tabs[0].subTabs[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs, eventType]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
    <Box>
      <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{eventMasterlistTitle}</Text>
    </Box>
      {previewEnabled ?
        <MyAccordionNested orientation="vertical" list={tabs} urlBasePath={`/${eventType}`} tabSegmentPosition={3} subTabSegmentPosition={4} includeAgraphy /> :
        <MyTabsNested orientation="vertical" list={tabs} urlBasePath={`/${eventType}`} tabSegmentPosition={3} subTabSegmentPosition={4} includeAgraphy />}
    </Stack>
  );
};

export default EditEventMasterlistRecord;